// router/index.js
import { createRouter, createWebHashHistory } from 'vue-router'
import HomePage from '@/pages/HomePage.vue'
import SurveyPage from '@/pages/SurveyPage.vue'
import ArtistCup from '@/pages/ArtistCup.vue'
import EngineerCup from '@/pages/EngineerCup.vue'
import StatsPage from '@/pages/StatsPage.vue'
import InfoPage from '@/pages/InfoPage.vue'

const routes = [
  { path: '/', component: HomePage },
  { path: '/info', component: InfoPage },
  { path: '/stats', component: StatsPage },
  
  // ���� ������ (��: /survey/:cupId)
  { path: '/survey/:cupId', component: SurveyPage },

  // ���� ������ ������ (/play/ArtistCup, /play/EngineerCup)
  { path: '/play/ArtistCup', component: ArtistCup },
  { path: '/play/EngineerCup', component: EngineerCup },
]

export default createRouter({
  history: createWebHashHistory(),
  routes
})
